import modSerializer from '@serializers/modSerializer.js'
import { LS_PURCHASES } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed, ref } from 'vue'
import pick from 'lodash/pick.js'

const PURCHASE_FIELDS = [
  'card_image',
  'date_live',
  'date_updated',
  'game_id',
  'game_name',
  'game_name_id',
  'id',
  'logo',
  'modfile',
  'name',
  'name_id',
  'price',
  'profile_url',
  'stats',
  'submitted_by',
  'summary',
  'tags',
  'wallet_gateways',
]

const purchasesState = useLocalStorage(LS_PURCHASES, null)
const fetchedPurchases = ref(false)

export default function () {
  const purchases = computed(() => JSON.parse(purchasesState.value))

  function clearPurchases() {
    purchasesState.value = JSON.stringify([])
  }

  function setMyPurchases(_purchases) {
    let { data } = modSerializer.transform({ data: _purchases })
    data = data.map((mod) => pick(mod, PURCHASE_FIELDS))
    purchasesState.value = JSON.stringify(data)
    return data
  }

  function getPurchasesForMod(modId) {
    modId = Number(modId)
    if (!isArray(purchases.value)) return []

    return purchases.value.filter((p) => p?.id === modId)
  }

  function getWalletGatewaysForMod(modId) {
    const rows = getPurchasesForMod(modId)
    const gateways = rows.map((r) => r.wallet_gateways).filter((g) => g != null)

    return [...new Set(gateways)]
  }

  function addPurchase(modId, modData, walletGateways) {
    const id = Number(modId)
    const entry = pick(
      {
        ...modData,
        wallet_gateways: walletGateways ?? modData?.wallet_gateways,
      },
      PURCHASE_FIELDS
    )

    let list = isArray(purchases.value) ? [...purchases.value] : []

    if (
      list.some(
        (p) => p?.id === id && p?.wallet_gateways === entry.wallet_gateways
      )
    ) {
      return
    }

    if (entry.wallet_gateways != null) {
      list = list.filter((p) => !(p?.id === id && p?.wallet_gateways == null))
    } else if (list.some((p) => p?.id === id)) {
      return
    }

    list.push(entry)
    setMyPurchases(list)
  }

  function removePurchase(modId) {
    modId = Number(modId)
    if (isArray(purchases.value)) {
      setMyPurchases(purchases.value.filter((m) => m.id !== modId))
    }
  }

  function modOwned(modId) {
    modId = Number(modId)
    return (
      isArray(purchases.value) && purchases.value.some((m) => m.id === modId)
    )
  }

  return {
    getWalletGatewaysForMod,
    getPurchasesForMod,
    fetchedPurchases,
    removePurchase,
    clearPurchases,
    setMyPurchases,
    addPurchase,
    purchases,
    modOwned,
  }
}
